import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_RatingInput.scss'
import SharpStar from '../Icons/SharpStar'
import PropTypes from 'prop-types';

class RatingInput extends React.Component {
  static propTypes = {
    numberOfStars: PropTypes.number,
    setRating: PropTypes.func.isRequired,
    ratingType: PropTypes.string.isRequired,
    grayed: PropTypes.bool
  }

  constructor (props) {
    super(props)

    this.myProps = props
    let numStars = 5
    if (this.myProps.numberOfStars > 0) {
      numStars = this.myProps.numberOfStars
    }

    this.state = {
      numberStars: numStars,
      currentRating: 0,
      numberStarsSelected: 0
    }
  }

  applyRating = function applyRating (selected) {
    this.setState({
      currentRating: selected
    })
    this.props.setRating(selected, this.props.ratingType)
  }

  onStarHover = function onStarHover (selected) {
    this.setState({
      numberStarsSelected: selected
    })
  }

  onStarLeave = function onStarLeave () {
    this.setState({
      numberStarsSelected: this.state.currentRating
    })
  }

  renderStar (index, isFullStar, className) {
    return <span
      onMouseEnter={(event) => this.onStarHover(index)}
      onMouseLeave={() => this.onStarLeave()}
      onClick={() => this.applyRating(index)}
      key={index} >
      <SharpStar key={index} className={className} full={isFullStar} size={3} cursorChanges />
    </span>
  }

  render () {
    let className = styles['starDefault']

    let stars = []
    if (this.state.currentRating === 0 && this.props.grayed) {
      className = styles['star-no-rating']
    }
    for (let currentStar = 1; currentStar <= this.state.numberStars; currentStar++) {
      let isFullStar = currentStar <= this.state.currentRating || currentStar <= this.state.numberStarsSelected
      stars.push(this.renderStar(currentStar, isFullStar, className))
    }

    return (
      <div>
        {stars}
      </div>
    )
  }
}

export default  (RatingInput)
